var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQUlEQVR42mMYBdjBU0nJM9gw0ZoX8vFhxSA5ojXXcnAgY+IMAUoiNGNiZAPSaGoAPkzYAAIYYQAekEYMHk3sCAAARL1t+X2a/EAAAAAASUVORK5CYII=";
  export default img;